/*
 * Users Messages
 *
 * This contains all the text for the Users container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.Users';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Users',
  },
  members: {
    id: `${scope}.members`,
    defaultMessage: 'Members',
  },
  usersTotal: {
    id: `${scope}.usersTotal`,
    defaultMessage: 'total',
  },
  addNew: {
    id: `${scope}.addNew`,
    defaultMessage: 'Add new',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },
  addUser: {
    id: `${scope}.addUser`,
    defaultMessage: 'Add User',
  },
  userDetails: {
    id: `${scope}.userDetails`,
    defaultMessage: 'User Details',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  enrolled: {
    id: `${scope}.enrolled`,
    defaultMessage: 'Enrolled',
  },
  user: {
    id: `${scope}.user`,
    defaultMessage: 'user',
  },
  siteOwner: {
    id: `${scope}.siteOwner`,
    defaultMessage: 'Site owner',
  },
  spaceOwner: {
    id: `${scope}.spaceOwner`,
    defaultMessage: 'Space owner',
  },
  spaceAdministrator: {
    id: `${scope}.spaceAdministrator`,
    defaultMessage: 'Space administrator',
  },
  administrator: {
    id: `${scope}.administrator`,
    defaultMessage: 'Administrator',
  },
  invite: {
    id: `${scope}.invite`,
    defaultMessage: 'Invite',
  },
  inviteMember: {
    id: `${scope}.inviteMember`,
    defaultMessage: 'Invite member',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
  pending: {
    id: `${scope}.pending`,
    defaultMessage: 'Pending',
  },
  membersLimit: {
    id: `${scope}.membersLimit`,
    defaultMessage: 'Membership limit reached, upgrade your subscription plan.',
  },
  deleteUserConfirmation: {
    id: `${scope}.deleteUserConfirmation`,
    defaultMessage: 'Are you sure you want to delete this user?',
  },
  createAccessCode: {
    id: `${scope}.createAccessCode`,
    defaultMessage: 'Create Access Code',
  },
});
